<template>
  <main>
    <Loader :loader="isLoading" />
    <section v-if="!isLoading && !showDenounces">
      <header class="grid grid-cols-1 md:flex gap-4 items-center mt-8 mb-6">
        <SelectButton
          v-model="denounceType"
          :options="options"
          aria-labelledby="basic"
          class="custom-buttonSelectForum col-span-12 md:col-span-4"
          :unselectable="false"
          @update:modelValue="changeDataTable()"
          :hasStatus="false"
        />
        <span
          class="p-input-icon-left col-span-12 md:col-span-3"
          :class="{ 'p-input-icon-right': params.title }"
          v-if="
            denounceType ===
            $t('labels.generic', {
              pt: 'Tópicos',
              en: 'Topics',
            })
          "
        >
          <i class="pi pi-search" />
          <InputText
            @keyup.enter="getDenouncesByTopicTitle()"
            type="text"
            v-model="inputTopicTitle"
            :placeholder="
              $t('labels.generic', {
                pt: 'Pesquisar por tópico',
                en: 'Search by topic',
              })
            "
            class="p-inputtext-sm h-[36px]"
          />
          <i
            class="pi pi-times"
            v-if="params.title"
            role="button"
            @click="clearSearch"
          />
        </span>
        <Dropdown
          @change="getDenouncesByStatus"
          :options="optionsStatusFilter"
          class="h-[36px] items-center flex col-span-12 md:col-span-3"
          v-model="statusOfDenounce"
          optionLabel="label"
        >
        </Dropdown>
      </header>
      <img
        src="@/assets/images/empty-denounce-comment-forum.svg"
        alt="empty denounces"
        class="w-[657px] mx-auto flex mt-32"
        v-if="
          totalDenounces === 0 &&
          denounceType ===
            $t('labels.generic', {
              pt: 'Comentários',
              en: 'Comments',
            })
        "
      />
      <img
        src="@/assets/images/empty-denounce-topic-forum.svg"
        alt="empty denounces"
        class="w-[657px] mx-auto flex mt-32"
        v-else-if="
          totalDenounces === 0 &&
          denounceType ===
            $t('labels.generic', {
              pt: 'Tópicos',
              en: 'Topics',
            })
        "
      />
      <div
        v-else-if="params.title && totalDenounces === 0"
        class="flex flex-col items-center justify-center w-full mt-16"
      >
        <img
          src="@/assets/images/result-empty.svg"
          alt="empty results"
          class="w-[37vw] md:w-[8vw] min-w-[136px]"
        />
        <span
          class="w-[80vw] md:w-full text-center text-base gap-2 flex flex-col mt-4 text-h-neutral-700 justify-center items-center"
        >
          <p class="font-extrabold">
            {{
              $t("labels.generic", { pt: "Sem resultados", en: "No results" })
            }}
          </p>
          <p class="font-semibold">
            {{
              $t("labels.generic", {
                pt: "Não foram encontrados denúncias com o termo pesquisado.",
                en: "No denounces were found with the search term.",
              })
            }}
          </p>
        </span>
        <button
          @click="clearParams"
          class="border btn-outline min-w-[143px] rounded font-bold h-8 w-[39vw] md:w-[9.9vw] mt-6 flex items-center justify-center text-base mb-32"
        >
          {{
            $t("labels.generic", { pt: "Limpar pesquisa", en: "Clean search" })
          }}
        </button>
      </div>
      <div v-else>
        <h5 v-if="denounceType === options[1]" class="mb-6">
          {{ $t("forum.listDenounces.topics.title") }}
        </h5>
        <h5 v-else class="mb-6">
          {{ $t("forum.listDenounces.comments.title") }}
        </h5>
        <div class="bg-white border border-gray-300 rounded-lg"></div>
        <DenoucedGroupList
          :commentsDenouncesList="commentsDenouncesList"
          :topicsDenouncesList="topicsDenouncesList"
          :statusOfDenounce="statusOfDenounce"
          :denounceType="denounceType"
          :size="numberOfDenouncesPerPage"
          :total="totalDenounces"
          @paginate="changePage"
          @denounces="setTableOfDenounces"
          @displayedItem="setDisplayedItem"
        />
      </div>
    </section>
    <section v-show="showDenounces">
      <TableDenounces
        :denounceComments="denounceComment"
        :denounceTopic="denounceTopic"
        :denounceType="denounceType"
        @closeTableDenounces="closeTableDenounces"
        @displayedItem="setDisplayedItem"
        @updateDenounces="getDenouncesByType"
      />
    </section>
    <Dialog
      :modal="true"
      v-model:visible="isVisibleDisplayedItemDialog"
      :style="{ maxWidth: '780px', height: '100vh' }"
      class="w-11/12 custom-dialogForum"
    >
      <template #header>
        <div class="flex justify-start w-full">
          <h2
            v-if="isCommentDenounces()"
            class="text-xl !font-medium text-black"
          >
            {{
              $t("labels.generic", {
                pt: "Comentário denúnciado",
                en: "Reported comment",
              })
            }}
          </h2>
          <h2 v-else class="text-xl !font-medium text-black">
            {{
              $t("labels.generic", {
                pt: "Tópico denúnciado",
                en: "Reported topic",
              })
            }}
          </h2>
        </div>
      </template>
      <div
        class="w-full min-h-[calc(100vh-128px)] p-4 flex items-center justify-center overflow-auto"
      >
        <div class="w-full">
          <div class="h-4/5 w-full">
            <header class="flex items-center mb-6">
              <div v-if="!displayedItem.userAuthor.photoProfile">
                <img
                  class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer"
                  src="@/assets/images/user-topic.svg"
                  alt="user"
                />
              </div>
              <div v-else-if="displayedItem.userAuthor.photoProfile">
                <img
                  class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer"
                  :src="displayedItem.userAuthor.photoProfile.path"
                  alt="user"
                />
              </div>
              <div>
                <h6 class="text-base font-bold text-h-neutral-700">
                  {{ displayedItem?.userAuthor?.name }}
                </h6>
                <p class="text-sm text-h-neutral-700">
                  {{
                    $t("labels.generic", {
                      pt: "Publicado em",
                      en: "Published in",
                    })
                  }}
                  {{ showCreationDate(displayedItem.created) }}
                </p>
              </div>
            </header>
            <h4
              v-show="!isCommentDenounces()"
              class="text-2xl leading-8 font-medium break-all"
            >
              {{ displayedItem.title }}
            </h4>
            <div class="custom-quill">
              <p
                v-if="isCommentDenounces()"
                v-html="displayedItem.comment"
                class="ql-editor !p-0 mt-4 text-[14px]"
              />
              <p
                v-else
                v-html="displayedItem.description"
                class="ql-editor !p-0 mt-4 text-[14px]"
              />
              <div
                v-if="displayedItem.media"
                class="!w-full flex justify-center bg-black mt-6"
              >
                <Image
                  :src="displayedItem.media.path"
                  alt="topic image"
                  preview
                  imageClass="!w-full !object-cover !h-[600px] !min-h-[150px] !max-h-[450px] "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          class="h-8 !py-1.5 !px-2 flex gap-1 btn-primary"
          severity="secondary"
          autofocus
          @click="toggleStateDisplayedItemDialog(false), (showDenounces = true)"
        >
          <v-icon name="md-listalt-round" />
          {{ $t("labels.generic", { pt: "Ver denúncias", en: "See reports" }) }}
        </Button>
      </template>
    </Dialog>
  </main>
</template>
<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";
import { ForumService } from "../forum.service";
import {
  DenounceStatus,
  DenounceTopic,
  DenouncedComment,
} from "@/models/denounce.model";
import { QueryParams } from "@/models/query-params.model";
import { take } from "rxjs";
import moment from "moment";

const DenoucedGroupList = defineAsyncComponent(
  () =>
    import(
      "@/views/CourseStudent/Forum/components/DenouncedGroupList/denounced-group-list.vue"
    )
);
const TableDenounces = defineAsyncComponent(
  () =>
    import(
      "@/views/CourseStudent/Forum/ListDenounces/TableDenounces/table-denounces.vue"
    )
);
export default defineComponent({
  name: "list-denounce",
  components: {
    DenoucedGroupList,
    TableDenounces,
  },
  data() {
    return {
      denounceType: this.$t("labels.generic", {
        pt: "Comentários",
        en: "Comments",
      }),
      options: [
        this.$t("labels.generic", { pt: "Comentários", en: "Comments" }),
        this.$t("labels.generic", { pt: "Tópicos", en: "Topics" }),
      ],
      totalDenounces: 0,
      numberOfDenouncesPerPage: 0,
      commentsDenouncesList: [] as Array<DenouncedComment>,
      topicsDenouncesList: [] as Array<DenounceTopic>,
      denounceComment: new DenouncedComment(),
      denounceTopic: new DenounceTopic(),
      params: new QueryParams(),
      isLoading: true,
      inputTopicTitle: "",
      showDenounces: false,
      statusOfDenounce: {
        label: this.$t("labels.generic", {
          pt: "Esperando revisão",
          en: "Waiting for review",
        }),
        value: DenounceStatus.WAITING_REVIEW,
      },
      optionsStatusFilter: [
        {
          label: this.$t("labels.generic", {
            pt: "Esperando revisão",
            en: "Waiting for review",
          }),
          value: DenounceStatus.WAITING_REVIEW,
        },
        {
          label: this.$t("labels.generic", {
            pt: "Não aceito",
            en: "Not accepted",
          }),
          value: DenounceStatus.NOT_ACCEPTED,
        },
        {
          label: this.$t("labels.generic", { pt: "Aceito", en: "Accepted" }),
          value: DenounceStatus.ACCEPTED,
        },
      ],
      isVisibleDisplayedItemDialog: false,
      displayedItem: {} as any,
    };
  },
  mounted() {
    this.getDenouncesByStatus();
    this.getRouteParams();
  },
  methods: {
    setDisplayedItem(denounce: DenounceTopic | DenouncedComment): void {
      if (!this.isCommentDenounces()) {
        this.displayedItem = (denounce as DenounceTopic).topic;
        this.denounceTopic = denounce;
        this.denounceComment = new DenouncedComment();
      } else {
        this.displayedItem = (denounce as DenouncedComment).comment;
        this.denounceComment = denounce;
        this.denounceTopic = new DenounceTopic();
      }
      this.toggleStateDisplayedItemDialog(true);
    },
    toggleStateDisplayedItemDialog(state: boolean): void {
      this.isVisibleDisplayedItemDialog = state;
    },
    showCreationDate(date: number[]): string {
      const [year, mounth, day, hours, minutes, seconds] = date;
      let creationDate = new Date(
        year,
        mounth - 1,
        day,
        hours,
        minutes,
        seconds
      );
      return this.formatDate(creationDate.toISOString());
    },
    formatDate(date: string): string {
      let result: any = date.split(" ");
      result = moment(result[0])
        .local(true)
        .format(
          `DD/MM/YYYY [${this.$t("labels.generic", {
            pt: "às",
            en: "at",
          })}] HH:mm`
        );
      return result;
    },
    changeDataTable(): void {
      this.clearParams();
      this.getDenouncesByStatus();
    },
    getAllDenouncesComment(): void {
      this.isLoading = true;
      this.service.denounces.pipe(take(1)).subscribe({
        next: (response) => {
          this.commentsDenouncesList = response.content[0].denouncedComments;
          this.totalDenounces = response.total;
          this.numberOfDenouncesPerPage = response.size;
          this.isLoading = false;
        },
      });
      this.service.getAllDenouncesComment(this.params);
    },
    getAllDenouncesTopic(): void {
      this.isLoading = true;
      this.service.denounces.pipe(take(1)).subscribe({
        next: (response) => {
          this.numberOfDenouncesPerPage = response.size;
          this.topicsDenouncesList = response.content;
          this.totalDenounces = response.total;
          this.isLoading = false;
        },
      });
      this.service.getAllDenouncesTopic(this.params);
    },
    getDenouncesByTopicTitle(): void {
      this.params.title = this.inputTopicTitle;
      this.params.page = 0;
      this.$router.push({
        name: "listForums",
        query: {
          ...this.$route.query,
          page: this.params.page,
          title: this.params.title,
        },
      });
      this.getAllDenouncesTopic();
    },
    getRouteParams(): void {
      if (this.$route.query) {
        this.params = {
          page: Number(this.$route.query.page) || 0,
          size: this.numberOfDenouncesPerPage || 10,
        };
      }
    },
    getDenouncesByStatus(): void {
      this.params.status = this.statusOfDenounce.value;
      this.params.denounceStatus = this.statusOfDenounce.value;
      this.params.page = 0;
      this.$router.push({
        name: "listForums",
        query: { ...this.$route.query, page: this.params.page },
      });
      this.getDenouncesByType();
    },
    clearParams(): void {
      this.params.page = 0;
      this.inputTopicTitle = "";
      this.params.title = undefined;
      this.$router.push({
        name: "listForums",
        query: {
          ...this.$route.query,
          page: this.params.page,
          title: this.params.title,
        },
      });
    },
    clearSearch(): void {
      this.inputTopicTitle = "";
      this.params.title = "";

      this.$router.push({
        name: "listForums",
        query: {
          ...this.$route.query,
          title: this.params.title,
        },
      });

      this.getDenouncesByType();
    },
    isCommentDenounces(): boolean {
      return (
        this.denounceType ===
        this.$t("labels.generic", { pt: "Comentários", en: "Comments" })
      );
    },
    getDenouncesByType(): void {
      if (this.isCommentDenounces()) {
        this.getAllDenouncesComment();
      } else {
        this.getAllDenouncesTopic();
      }
    },

    changePage(params: QueryParams): void {
      this.params.status = this.statusOfDenounce.value;
      this.params.denounceStatus = this.statusOfDenounce.value;
      this.params = { ...this.params, page: params.page, size: params.size };
      this.$router.push({
        name: "listForums",
        query: { ...this.$route.query, page: params.page, size: params.size },
      });
      this.getDenouncesByType();
    },
    setTableOfDenounces(denounce: DenouncedComment | DenounceTopic): void {
      if (this.isCommentDenounces()) {
        this.denounceComment = denounce as DenouncedComment;
        this.denounceTopic = new DenounceTopic();
      } else {
        this.denounceTopic = denounce as DenounceTopic;
        this.denounceComment = new DenouncedComment();
      }
      this.showDenounces = true;
    },
    closeTableDenounces(): void {
      this.showDenounces = false;
    },
  },
  computed: {
    service(): ForumService {
      return new ForumService();
    },
  },
});
</script>
